import { ALL_LANGS, FALLBACK_LANG } from "~/const";
import type { IDeepObject } from "~/interfaces";
import { langStore } from "~/stores/lang";

export function getLang(langKey: string): string {
	const allLangs = [];

	Object.keys(ALL_LANGS).forEach(key => {
		allLangs.push(ALL_LANGS[key]);
	});

	const ind = allLangs.findIndex(lang => lang === langKey);

	return ind === -1 ? FALLBACK_LANG : langKey;
}

async function loadLanguageFromFile(langKey: string): Promise<IDeepObject> {
	try {
		// v devu nefunguje lang random version!
		const langModule = await import(/* webpackChunkName: "[request]" */ `../../public/lang-${langKey}`);

		// z nepochopitelneho duvodu export en jazyka vyhazuje vyjimka - trans-script, proto se neexportuji data, ale nastavi se do window
		return Promise.resolve(langModule.default || window.i18nData || {});
	} catch (exc) {
		/* eslint-disable no-console */
		console.log(exc);

		return Promise.reject(exc);
	}
}

export async function loadLanguage(langKey: string) {
	const store = langStore.getState();
	const lang = getLang(langKey);

	if (store.data.loadedLangs.filter(item => item.lang === lang).length === 1) {
		store.setLang(lang);

		return;
	}

	try {
		const transData = await loadLanguageFromFile(lang);

		store.loadLang(lang, transData as any);
	} catch (ex) {
		/* eslint-disable no-console */
		console.log(ex);
	}
}

export function getBrowserLang() {
	/* eslint-disable-next-line */
	const browserLangs = navigator.languages.map(item => item.slice(0, 2));
	const langs = [...new Set(browserLangs)];
	const mainLanguage = langs[0] || "";

	switch (mainLanguage) {
		case ALL_LANGS.czech:
		case ALL_LANGS.slovak:
			return ALL_LANGS.czech;

		default:
			return ALL_LANGS.english;
	}
}
